import React from 'react';
import styled from 'styled-components';
import { ShadowTheme } from '../../../components/globaStyledComponents/globalStyledComponentsStyling';

const MapPopupButtonContainer = styled.div`
    position: absolute;
    right: 24px;
    bottom: 24px;
    width: 44px;
    height: 44px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(16px);
    border-radius: 50%;
    box-shadow: ${ShadowTheme.shadow_200.boxShadow};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.3);
    transition: all 0.2s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.9);
        transform: scale(1.05);
    }

    &:active {
        background-color: rgba(255, 255, 255, 1);
        transform: scale(0.95);
    }
`;

interface MapPopupButtonProps {
    onClick: () => void;
}

const MapPopupButton: React.FC<MapPopupButtonProps> = ({ onClick }) => {
    return (
        <MapPopupButtonContainer onClick={onClick} aria-label="Open larger map">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M15 3h6v6"/>
                <path d="m21 3-7 7"/>
                <path d="m3 21 7-7"/>
                <path d="M9 21H3v-6"/>
            </svg>
        </MapPopupButtonContainer>
    );
};

export default MapPopupButton;
